import type { LocalizedLabel } from "@/domain/types";

/** Short checkpoint names for the "over time" rows; other IDs use the full title. */
export const CHECKPOINT_SHORT_NAMES: Record<string, LocalizedLabel> = {
  "A.1": { en: "Targeting all ages", no: "Alle aldersgrupper" },
  "A.2": { en: "All levels of risk", no: "Alle risikonivåer" },
  "A.3": { en: "All settings", no: "Alle arenaer" },
  "A.4": { en: "Risk & protective factors", no: "Risiko- og beskyttelsesfaktorer" },
  "B.1": { en: "Funding requires evidence", no: "Finansiering krever kunnskap" },
  "B.2": { en: "Mandatory in education", no: "Påbudt i utdanning" },
  "B.3": { en: "Mandatory in workplaces", no: "Påbudt på arbeidsplasser" },
  "B.4": { en: "Brief interventions in care", no: "Korte intervensjoner i helsetjenesten" },
  "B.5": { en: "Alcohol & nicotine policies", no: "Alkohol- og nikotinpolitikk" },
  "B.6": { en: "Other societal sectors", no: "Andre samfunnssektorer" },
  "C.1": { en: "School survey ≤ 3 years", no: "Skoleundersøkelse ≤ 3 år" },
  "C.2": { en: "Survey results used", no: "Undersøkelsesresultater brukes" },
  "C.3": { en: "Evaluation supported", no: "Evaluering støttes" },
  "C.4": { en: "Evaluation used", no: "Evaluering brukes" },
  "D.1": { en: "National coordination", no: "Nasjonal koordinering" },
  "D.2": { en: "Regional coordination", no: "Regional koordinering" },
  "D.3": { en: "Local coordination", no: "Lokal koordinering" },
  "D.4": { en: "Policy coherence", no: "Samstemt politikk" },
  "E.1": { en: "Training for deliverers", no: "Opplæring for utøvere" },
  "E.2": { en: "Training for decision makers", no: "Opplæring for beslutningstakere" },
  "F.1": { en: "Medium-term policy (3–5 years)", no: "Mellomlang plan (3–5 år)" },
  "F.2": { en: "Adequately funded", no: "Tilstrekkelig finansiert" },
  "F.3": { en: "Ethical implementation", no: "Etisk gjennomføring" },
};
